import { render } from "./PurchaseNavbar.vue?vue&type=template&id=10fcae9c&scoped=true"
import script from "./PurchaseNavbar.vue?vue&type=script&lang=js"
export * from "./PurchaseNavbar.vue?vue&type=script&lang=js"

import "./PurchaseNavbar.vue?vue&type=style&index=0&id=10fcae9c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fcae9c"]])

export default __exports__